import { useEffect } from "react";
import { BUSINESS } from "@/data/site";

const DEFAULT_IMG = "https://images.unsplash.com/photo-1614595737476-42487331b8a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, image }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${BUSINESS.shortName}` : `${BUSINESS.name} — Belize Construction & Development`;
    const desc = description || "Belize-based construction & development specializing in residential and commercial builds, waterfront structures, docks, seawalls and land development for 12+ years.";
    const img = image || DEFAULT_IMG;
    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:image", img);
    setMeta("property", "og:type", "website");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", img);
  }, [title, description, image]);
  return null;
};
